<template>
  <DefaultLayout>
    <AgentChat :agent-id="Number(agentId)" />
  </DefaultLayout>
</template>

<script setup>
import { defineProps } from 'vue';
import DefaultLayout from '../components/layout/DefaultLayout.vue';
import AgentChat from '../components/agents/AgentChat.vue';

const props = defineProps({
  agentId: { type: String, required: true },
});
const { agentId } = props;
</script>
